import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/faq/groups.ts
import { Exception } from "@wbk/logger";
import { getLocaleOnly } from "@wbk/utils";
var getFaqsGroups = (params) => __async(null, null, function* () {
  try {
    const search = new URLSearchParams();
    search.append("lang", getLocaleOnly((params == null ? void 0 : params.locale) || "en"));
    if (params == null ? void 0 : params.organization_slug) {
      search.append("organization_slug", params.organization_slug);
    }
    const data = yield fetchClient({
      url: `/faq-groups?${search.toString()}`
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getFaqsGroupsException"
    });
  }
});

export {
  getFaqsGroups
};
//# sourceMappingURL=chunk-P4HT4TD5.mjs.map